import { captureRemixErrorBoundaryError } from "@sentry/remix";
import { ErrorComponent as UIErrorComponent } from "@worship-devo/ui";
import posthogClient from "posthog-js";
import { useEffect } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

export function capturePostHogRouteError(error: unknown): void {
  if (isRouteErrorResponse(error) || !(error instanceof Error)) {
    return;
  }

  posthogClient.captureException(error, {
    error_boundary: "react_router",
  });
}

export function ErrorComponent() {
  const error = useRouteError();
  console.error(error);
  const isRouteError = isRouteErrorResponse(error);
  captureRemixErrorBoundaryError(error);

  useEffect(() => {
    capturePostHogRouteError(error);
  }, [error]);

  const title = isRouteError ? error.statusText : "Unknown Error";
  let description = "An unknown error occurred.";

  if (isRouteError) {
    switch (error.status) {
      case 404:
        description = "Sorry, we couldn't find the page you're looking for.";
        break;
      case 401:
        description = "You are not authorized to view this page.";
        break;
      case 403:
        description = "You are not authorized to view this page.";
        break;
      case 500:
        description = "An error occurred on the server.";
        break;
      default:
        description = "An unknown error occurred.";
        break;
    }
  }
  return (
    <UIErrorComponent
      status={isRouteError ? error.status : undefined}
      title={title}
      description={description}
      action={<Link to="/">Go back home</Link>}
    />
  );
}
